import { render, staticRenderFns } from "./projectReports.vue?vue&type=template&id=8c65bfca&"
import script from "./projectReports.vue?vue&type=script&lang=js&"
export * from "./projectReports.vue?vue&type=script&lang=js&"
import style0 from "./projectReports.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports